// extracted by css-extract-rspack-plugin
export default {"cls1":"Search-cls1_oPD","cls2":"Search-cls2_vO_ Search-cls1_oPD"};